import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Globe, Copy, ExternalLink } from "lucide-react";
import { toast } from "sonner";
import { Link } from "react-router-dom";

const PUBLIC_HOSTS = [
  { host: "orevital.com", label: "OreVital" },
  { host: "mindfulminerals.com", label: "Mindful Minerals" },
];

export default function DealerPageCard({ slug, embedded = false }) {
  if (!slug) return null;

  async function copy(url) {
    await navigator.clipboard.writeText(url);
    toast.success("Link copied");
  }

  const links = (
    <ul className="space-y-1.5" data-testid="dealer-page-links">
      {PUBLIC_HOSTS.map(({ host, label }) => {
        const url = `https://${host}/d/${slug}`;
        return (
          <li
            key={host}
            className="flex items-center justify-between gap-2 rounded-lg bg-white border border-zinc-200 px-3 py-2"
            data-testid={`dealer-url-${label.toLowerCase().replace(/\s+/g, "-")}`}
          >
            <div className="min-w-0 flex-1">
              <div className="text-[10px] uppercase tracking-wider text-zinc-400 font-semibold">
                {label}
              </div>
              <div className="text-xs text-zinc-700 truncate font-mono">
                {host}/d/<span className="font-semibold text-violet-700">{slug}</span>
              </div>
            </div>
            <div className="flex items-center gap-1 shrink-0">
              <Button
                type="button"
                variant="ghost"
                size="icon"
                className="h-8 w-8 text-zinc-500 hover:text-zinc-900"
                onClick={() => copy(url)}
                aria-label="Copy"
              >
                <Copy size={14} />
              </Button>
              <Link
                to={`/d/${slug}`}
                className="h-8 w-8 inline-flex items-center justify-center text-zinc-500 hover:text-violet-700"
                aria-label="Open"
              >
                <ExternalLink size={14} />
              </Link>
            </div>
          </li>
        );
      })}
    </ul>
  );

  if (embedded) {
    return (
      <div className="space-y-1.5" data-testid="dealer-page-card">
        <div className="flex items-center gap-1.5 text-[11px] text-zinc-500">
          <Globe size={13} className="text-amber-600" />
          Your dealer page — share these links anywhere, they all point to your public page.
        </div>
        {links}
      </div>
    );
  }

  return (
    <Card
      className="rounded-2xl border-amber-200 bg-amber-50/40 p-4"
      data-testid="dealer-page-card"
    >
      <div className="flex items-start gap-3 mb-3">
        <div className="w-9 h-9 rounded-lg bg-amber-100 flex items-center justify-center shrink-0">
          <Globe className="text-amber-700" size={18} />
        </div>
        <div className="flex-1">
          <div className="font-semibold text-zinc-900">Your dealer page</div>
          <p className="text-xs text-zinc-500 mt-0.5">
            Share these links anywhere — they all point to your public page.
          </p>
        </div>
      </div>
      {links}
    </Card>
  );
}
